import {
  ILanguageAutocompleteValue,
  TGetAllLanguagesGroupedByPopularity,
} from "./types";
import langs from "langs";

export const getAllLanguagesGroupedByPopularity: TGetAllLanguagesGroupedByPopularity =
  (popular) => {
    const allLangs = langs.all();

    const allLanguages: ILanguageAutocompleteValue[] = allLangs.map((lang) => ({
      id: lang["3"],
      name: lang.name,
      popularity: "All",
    }));

    const popularLanguages: ILanguageAutocompleteValue[] = popular.map(
      (lang) => {
        const language = langs.where(3, lang);

        if (!language)
          throw Error(`Provided popular language is incorrect: ${lang}`);

        return {
          id: language["3"],
          name: language.name,
          popularity: "Most Popular",
        };
      },
    );

    return [...popularLanguages, ...allLanguages];
  };
